export const DEFAULT_PER_PAGE = 25
export const ROWS_PER_PAGE = [25, 100, 200]
